import { render } from "./FormCreation.vue?vue&type=template&id=78f704bc&scoped=true"
import script from "./FormCreation.vue?vue&type=script&lang=ts"
export * from "./FormCreation.vue?vue&type=script&lang=ts"

import "./FormCreation.vue?vue&type=style&index=0&id=78f704bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78f704bc"

export default script